export const PUBLIC_CONTACT_EMAIL = 'alfadli.rai@gmail.com';

export const contactCopy = {
  pending: 'Sending your message…',
  successTitle: 'Message sent',
  successBody:
    'Thanks for reaching out. I received your message and will reply by email when I can.',
  validationSummary: 'Please fix the highlighted fields and try again.',
  requestRejected:
    'This request could not be accepted. Check that you are using the site directly and try again.',
  requestError:
    'The message could not be sent in its current form. Review the details below and try again.',
  challengePrompt:
    'Additional verification is required. Complete the check below, then send again.',
  verificationFailed:
    'Verification did not complete. Try the check again with a fresh attempt.',
  rateLimited: (seconds: number) =>
    `Too many attempts. You can try again in about ${seconds} seconds.`,
  deliveryError:
    'The message could not be delivered right now. You can retry safely or email me directly.',
  networkError:
    'The connection timed out or failed. Your message is still here — retry safely with the same details.',
  payloadTooLarge:
    'Your message is too long to send. Shorten it to 5,000 characters or fewer, then retry.',
  unsupportedMedia:
    'The browser sent an unsupported request format. Refresh the page and try again.',
  methodNotAllowed:
    'This contact form must be submitted from the website. Refresh and try again.',
  directEmailLabel: `Email ${PUBLIC_CONTACT_EMAIL} directly`,
  directEmailHint:
    'If delivery keeps failing, use your email app to reach me without losing what you wrote.',
  submitLabel: 'Send message',
  submittingLabel: 'Sending…',
  retryLabel: 'Try again',
} as const;
